import { render, staticRenderFns } from "./UserAccounts.vue?vue&type=template&id=420193fc"
import script from "./UserAccounts.vue?vue&type=script&lang=js"
export * from "./UserAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports